import { ChecklistTemplatesAdmin } from "@/components/ChecklistTemplatesAdmin";

export default function ChecklistTemplatesPage() {
  return <ChecklistTemplatesAdmin />;
}
